module.exports = __webpack_public_path__ + "media/categories/1053-3d80aac9.svg";